import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';

import ArticleLayout from './ArticleLayout';
import type { ArticleProps } from './interfaces';

const Article = (props: ArticleProps) => {
  const [queryClient] = React.useState(() => new QueryClient());

  return (
    <AppContextProvider
      env={props.env}
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
      isNativeApp={props.isNativeApp}
      isWebview={props.isWebview}
      nativeAppVersion={props.nativeAppVersion}
      showBookmarksFlagEnabled={props.showBookmarksFlagEnabled}
    >
      <QueryClientProvider client={queryClient}>
        <ArticleLayout {...props} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default Article;
